import Mailchimp from '@/components/SignUpForm/Mailchimp';
import BaseFormView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFVideoReplay2 from '@/components/UI/svg/Icons/EFVideoReplay2';
import { useCountDown } from '@/utils/useCountDown';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { useRef } from 'react';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/mh200/');

export default function MhA() {
    const { useEffect, useState, useLang, useRouter, isMobile, gtm } = useGlobal();
    const { locale } = useRouter();
    const videoExtMap: any = {
        us: 'fahrenheit',
        jp: 'celsius',
        cn: 'celsius',
        au: 'celsius',
        ca: 'celsius',
        za: 'celsius',
        sa: 'celsius',
    };
    const videoLocal = videoExtMap[locale] || videoExtMap['us'];
    const { t } = useLang('waveportableairconditioner');
    const [isEnter, setIsEnter] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const videoPath = isMobile ? 'kv_pc' : 'kv_pc';
    const videoRef = useRef(null);
    const northAmerica = ['us', 'ca'];
    const endTime = process.env.NEXT_PUBLIC_MH200_AU_PRESALE_START;
    const [isAuPreview, setIsAupreview] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/mLCDXIC9lGo',
        cn: {
            SD: 'https://videos.ecoflow.com/9f2330ee3d74429e8df9eb2191645d90/e4ae3cbbaae84ea5beffb52cd50cd68b-156f1f27124519527f4d099ee5a8c5aa-fd.mp4',
            HD: 'https://videos.ecoflow.com/9f2330ee3d74429e8df9eb2191645d90/e4ae3cbbaae84ea5beffb52cd50cd68b-048935340bb5bed52056bc242e7e0115-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/3ee3133-182eddeaf83-0004-9c91-e6d-40030.mp4',
        },
    };

    useEffect(() => {
        setIsEnter(true);
        try {
            videoRef.current?.play();
        } catch (e: any) {}
    }, []);

    useEffect(() => {
        // 仅澳洲站生效
        const product_naver = document.querySelector('section.product_naver');
        product_naver?.classList.remove('hideBuy');
    }, [isAuPreview]);

    useCountDown({
        endTime: endTime || '',
        interval: 1000,
        onUpdate(timeLeft) {
            if (locale !== 'au') {
                isAuPreview && setIsAupreview(false);
                return;
            }
            if (timeLeft <= 0) {
                setIsAupreview(false);
            } else if (!isAuPreview) {
                setIsAupreview(false);
            }
        },
    });

    return (
        <div className={`${css.mhA} mhA ${isMobile ? 'mhA-h5' : 'mhA-pc'} ${isAuPreview ? 'auPreview' : ''}`}>
            <div className="sticky">
                {!northAmerica.includes(locale) && (
                    <div className="video-box">
                        <EFVideo
                            ref={videoRef}
                            className="video"
                            sources={[`/video/Mh200/${videoPath}_${videoLocal}.webm`, `/video/Mh200/${videoPath}_${videoLocal}.mp4`]}
                        />
                    </div>
                )}
                {northAmerica.includes(locale) && (
                    <div className="imgBox">
                        <EFPic
                            name={[`${isMobile ? 'h5/' : 'pc/'}mh200_${locale}.webp`, `${isMobile ? 'h5/' : 'pc/'}mh200_${locale}.jpg`]}
                            className="fullImgs"
                            alt={t('mh200.mhA_title')}
                        />
                    </div>
                )}
                <div className={`v-msg ${isEnter ? 'isEnter' : ''}`}>
                    <div className="v-msg-title">{t('mh200.mhA_title')}</div>
                    <div className="v-msg-imgbox2" onClick={() => setShowEFVideoModal(true)}>
                        {t('mh200.watch_video')}
                        <EFVideoReplay2 className="arrow-triangle-right" />
                    </div>
                </div>
                {isAuPreview && (
                    <div className="email-wrap">
                        <div className="email-content">
                            <div className="email-title">Available on 10.10</div>
                            <div className="email-msg">Sign up for exclusive offers and to get notified when early-bird prices go live.</div>
                            <div className="email-input">
                                <Mailchimp
                                    successCallback={() => {
                                        console.log('open Popup');
                                        setPopupOpen(true);
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'Subscribe',
                                            status: 'success',
                                        });
                                        window?.fbq('track', 'Subscribe');
                                    }}
                                    errorCallback={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: 'Subscribe',
                                            status: 'fail',
                                        });
                                    }}
                                >
                                    <BaseFormView
                                        submitText="Subscribe"
                                        action="https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=8eeef724a3&f_id=00138fe4f0"
                                    />
                                </Mailchimp>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Popup
                visible={popupOpen}
                onCancel={() => setPopupOpen(false)}
                title="You're in!"
                content="You'll receive an exlusive discount when pre-ordering goes live! Follow us on Facebook to chat with other enthusiasts and learn from Wave experts."
                buttonText="FOLLOW US"
                facebookUrl="https://www.facebook.com/ecoflowaustralia"
            />
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
